<template>
  <a-card class="buy__card--div" style="height:100%">
        <img :src="successImg" alt="" style="margin-bottom:40px" />
    <h1>支付成功
    </h1>
    <a-button size="large"  @click="backToUserMessage" style="margin-top:30px" >返回</a-button>
  </a-card>
</template>
<script>
export default {
  name: "PaySuccess",
  data() {
    return {
      successImg:require("@/assets/success.png")
    };
  },

  methods: {
    backToUserMessage(){
      let path = '/user-message/index'
        this.$router.push(path);
    }
  },
};
</script>
<style lang="less" scoped>
@import "./index.less";
</style>